const RenderTexture = require('../../../assets/CCRenderTexture');

function MyAtlas(width, height) {
    let texture = new RenderTexture();
    texture.initWithSize(width, height);
    texture.update();

    this._texture = texture;

    this._innerTextureInfos = {};
   // this._innerSpriteFrames = [];
   this._innerSpriteFrames={}

    this._count = 0;
}

MyAtlas.DEFAULT_HASH = (new RenderTexture())._getHash();

cc.js.mixin(MyAtlas.prototype, {
    insertSpriteFrame(spriteFrame, info) {
        let frame = {
            x: null,
            y: null,
            texture: null
        }
        let rect = spriteFrame._rect;
        if (info.isSame) { //有相同的 直接返回
            let spInfo = this._innerTextureInfos[spriteFrame._texture._uuid];
            frame.x = spInfo.x + rect.x;
            frame.y = spInfo.y + rect.y;
            frame.texture = this._texture
          //  return frame;
        } else { //莫得 绘制
            //
            let _x = info.rect.x;
            let _y = info.rect.y;
            let _texture = spriteFrame._texture;
            if (spriteFrame._texture.width <= 8 || spriteFrame._texture.height <= 8) {
                this._texture.drawTextureAt(_texture, _x - 1, _y - 1);
                this._texture.drawTextureAt(_texture, _x - 1, _y + 1);
                this._texture.drawTextureAt(_texture, _x + 1, _y - 1);
                this._texture.drawTextureAt(_texture, _x + 1, _y + 1);
            }
            this._texture.drawTextureAt(_texture, _x - 1, _y);
            this._texture.drawTextureAt(_texture, _x + 1, _y);
            this._texture.drawTextureAt(_texture, _x, _y - 1);
            this._texture.drawTextureAt(_texture, _x, _y + 1);

            this._texture.drawTextureAt(spriteFrame._texture, _x, _y);
            this._innerTextureInfos[spriteFrame._texture._uuid] = {
                x: _x,
                y: _y,
                texture: this._texture
            }
            this._count++;
            this._dirty = true;
            frame.x = _x + rect.x;
            frame.y = _y + rect.y;
            frame.texture = this._texture;
        }
        //
        this._innerSpriteFrames[spriteFrame._texture._uuid]=spriteFrame
        //this._innerSpriteFrames.push(spriteFrame); //这个确实挺重要
        return frame;
    },
    update() {
        if (!this._dirty) return;
        this._texture.update();
        this._dirty = false;
    },
    deleteInnerTexture(texture) {
        return; //这边不做处理，我们自己reset
        if (texture && this._innerTextureInfos[texture._uuid]) { //这里会销毁label 但是图集并不会重绘制..这边需要过滤掉
            let strs = texture._uuid.split("_");
            if (strs[strs.length - 1] === "label") return; //过滤掉label
            delete this._innerTextureInfos[texture._uuid];
            this._count--;
        }
    },
    isEmpty() {
        return this._count <= 0;
    },
    reset() {
        let frames = this._innerSpriteFrames;
       // for (let i = 0, l = frames.length; i < l; i++) {
        for(const key in frames)
        {
            let frame = frames[key];
            if (!frame.isValid) {
                continue;
            }
            frame._resetDynamicAtlasFrame();
        }
       // this._innerSpriteFrames.length = 0;
        this._innerSpriteFrames={};
        this._innerTextureInfos = {};
    },
    destroy() {
        this.reset();
        this._texture.destroy();
    }
});

module.exports = MyAtlas;
